import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { IQueryResult, ITemplate, ITemplatesQueryParams } from 'gen/ApiClient';

export const TemplatesQueryContext = React.createContext<IQueryContext<IQueryResult<ITemplate>, ITemplatesQueryParams>>(undefined as any);
